(function () {
  'use strict';

  function vibrate(pattern) {
    try {
      if (navigator.vibrate) navigator.vibrate(pattern);
    } catch (e) { /* ignore */ }
  }

  function detectAutomatedBrowser() {
    try {
      if (navigator.webdriver) return true;
      if (window.callPhantom || window._phantom) return true;
      if (window.__nightmare) return true;
      if (window.Cypress) return true;
      if (/HeadlessChrome/.test(navigator.userAgent)) return true;
    } catch (e) { /* ignore */ }
    return false;
  }

  CandyCatch.prototype.initAudio = function () {
    if (this.audioCtx || !this.soundEnabled) return;
    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (AC) this.audioCtx = new AC();
    } catch (e) { this.soundEnabled = false; }
  };

  CandyCatch.prototype.playTone = function (freq, duration, type, vol, sweepTo) {
    if (!this.soundEnabled || !this.audioCtx) return;
    var ctx = this.audioCtx;
    if (ctx.state === 'suspended') { ctx.resume(); }
    var osc = ctx.createOscillator();
    var gain = ctx.createGain();
    osc.type = type || 'sine';
    var now = ctx.currentTime;
    osc.frequency.setValueAtTime(freq, now);
    if (sweepTo) osc.frequency.exponentialRampToValueAtTime(Math.max(1, sweepTo), now + duration);
    var v = (vol != null ? vol : 0.2) * (this.soundVolume / 100);
    gain.gain.setValueAtTime(Math.max(0.0001, v), now);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + duration);
  };

  CandyCatch.prototype.playCatchCandy = function () {
    this.playTone(880, 0.09, 'sine', 0.25, 1200);
  };
  CandyCatch.prototype.playCatchSugar = function () {
    this.playTone(180, 0.2, 'square', 0.3, 90);
  };
  CandyCatch.prototype.playMiss = function () {
    this.playTone(320, 0.16, 'sawtooth', 0.2, 140);
  };
  CandyCatch.prototype.playFail = function () {
    var self = this;
    this.playTone(420, 0.2, 'square', 0.28, 320);
    setTimeout(function () { self.playTone(300, 0.2, 'square', 0.26, 220); }, 150);
    setTimeout(function () { self.playTone(180, 0.4, 'square', 0.28, 90); }, 320);
  };
  CandyCatch.prototype.playCountdownTick = function () {
    this.playTone(520, 0.08, 'square', 0.18);
  };
  CandyCatch.prototype.playGo = function () {
    this.playTone(700, 0.22, 'sine', 0.3, 1050);
  };

  function CandyCatch(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.failLimit = parseInt(root.dataset.failLimit, 10) || 3;
    this.missLimit = parseInt(root.dataset.missLimit, 10) || 10;
    this.pointsPerCandy = parseInt(root.dataset.pointsPerCandy, 10) || 1;
    this.startSpeed = parseFloat(root.dataset.startSpeed) || 3;
    this.speedIncrement = parseFloat(root.dataset.speedIncrement) || 0.02;
    this.startSpawn = parseInt(root.dataset.startSpawn, 10) || 1200;
    this.minSpawn = parseInt(root.dataset.minSpawn, 10) || 350;
    this.spawnDecrement = parseInt(root.dataset.spawnDecrement, 10) || 15;
    this.webhookUrl = root.dataset.webhookUrl || '';
    this.itemSize = parseInt(root.dataset.candySize, 10) || 56;
    this.catchZoneRatio = (parseInt(root.dataset.catchZoneWidth, 10) || 65) / 100;
    this.catchZoneHeightRatio = (parseInt(root.dataset.catchZoneHeight, 10) || 35) / 100;
    this.mobileBreakpoint = parseInt(root.dataset.mobileBreakpoint, 10) || 768;
    this.soundEnabled = root.dataset.soundEnabled === 'true';
    this.soundVolume = parseInt(root.dataset.soundVolume, 10);
    if (isNaN(this.soundVolume)) this.soundVolume = 50;
    this.audioCtx = null;

    this.el = {
      desktopMsg: root.querySelector('[data-cc-desktop-msg]'),
      playBtn: root.querySelector('[data-cc-open]'),
      overlay: root.querySelector('[data-cc-overlay]'),
      close: root.querySelector('[data-cc-close]'),
      close2: root.querySelector('[data-cc-close-2]'),
      formPanel: root.querySelector('[data-cc-form-panel]'),
      form: root.querySelector('[data-cc-form]'),
      formError: root.querySelector('[data-cc-form-error]'),
      blockedPanel: root.querySelector('[data-cc-blocked-panel]'),
      blockedClose: root.querySelector('[data-cc-blocked-close]'),
      howtoPanel: root.querySelector('[data-cc-howto-panel]'),
      howtoContinue: root.querySelector('[data-cc-howto-continue]'),
      leaderboardPanel: root.querySelector('[data-cc-leaderboard-panel]'),
      leaderboardList: root.querySelector('[data-cc-leaderboard-list]'),
      leaderboardEmpty: root.querySelector('[data-cc-leaderboard-empty]'),
      leaderboardContinue: root.querySelector('[data-cc-leaderboard-continue]'),
      leaderboardLoading: root.querySelector('[data-cc-leaderboard-loading]'),
      launcherLeaderboardList: root.querySelector('[data-cc-launcher-leaderboard-list]'),
      launcherLeaderboardEmpty: root.querySelector('[data-cc-launcher-leaderboard-empty]'),
      launcherLeaderboardLoading: root.querySelector('[data-cc-launcher-leaderboard-loading]'),
      gameoverLeaderboardList: root.querySelector('[data-cc-gameover-leaderboard-list]'),
      gameoverLeaderboardEmpty: root.querySelector('[data-cc-gameover-leaderboard-empty]'),
      gameoverLeaderboardLoading: root.querySelector('[data-cc-gameover-leaderboard-loading]'),
      countdown: root.querySelector('[data-cc-countdown]'),
      stage: root.querySelector('[data-cc-stage]'),
      playfield: root.querySelector('[data-cc-playfield]'),
      pouch: root.querySelector('[data-cc-pouch]'),
      score: root.querySelector('[data-cc-score]'),
      sugarCaught: root.querySelector('[data-cc-sugar-caught]'),
      sugarLimit: root.querySelector('[data-cc-sugar-limit]'),
      missCaught: root.querySelector('[data-cc-miss-caught]'),
      missLimitEl: root.querySelector('[data-cc-miss-limit]'),
      gameoverPanel: root.querySelector('[data-cc-gameover-panel]'),
      gameoverTitle: root.querySelector('[data-cc-gameover-title]'),
      gameoverCopy: root.querySelector('[data-cc-gameover-copy]'),
      finalScore: root.querySelector('[data-cc-final-score]'),
      savedMsg: root.querySelector('[data-cc-saved-msg]'),
      playAgain: root.querySelector('[data-cc-play-again]'),
      candyTpl: root.querySelector('[data-cc-candy-template]'),
      sugarTpl: root.querySelector('[data-cc-sugar-template]'),
      adminBoard: root.querySelector('[data-cc-admin-board]'),
      adminList: root.querySelector('[data-cc-admin-list]'),
      adminEmpty: root.querySelector('[data-cc-admin-empty]'),
      adminRefresh: root.querySelector('[data-cc-admin-refresh]'),
      adminLoading: root.querySelector('[data-cc-admin-loading]'),
      flash: root.querySelector('[data-cc-flash]'),
      pouchImg: root.querySelector('[data-cc-pouch-img]')
    };

    this.pairs = [];
    try {
      var pairsScript = root.querySelector('[data-cc-pairs]');
      if (pairsScript) {
        var parsed = JSON.parse(pairsScript.textContent);
        if (Array.isArray(parsed)) this.pairs = parsed;
      }
    } catch (e) { this.pairs = []; }

    this.player = { first_name: '', last_name: '', email: '' };
    this.automationDetected = detectAutomatedBrowser();
    this.movementSamples = [];
    this.suspectedCheat = false;
    this.sessionScores = [];
    this.cachedLeaderboard = [];
    this.reset();
    this.bind();
    this.checkIsMobile();
    this.showLauncherLeaderboard();
    window.addEventListener('resize', this.checkIsMobile.bind(this));

    if (window.Shopify && window.Shopify.designMode) {
      this.el.adminBoard.hidden = false;
      this.refreshLeaderboard();
    }
  }

  CandyCatch.prototype.reset = function () {
    this.score = 0;
    this.sugarCaught = 0;
    this.missedCandies = 0;
    this.speed = this.startSpeed;
    this.spawnInterval = this.startSpawn;
    this.pouchX = 0.5; // 0..1 across playfield
    this.items = [];
    this.running = false;
  };

  CandyCatch.prototype.checkIsMobile = function () {
    var isMobile = window.innerWidth <= this.mobileBreakpoint;
    this.isMobile = isMobile;
    if (this.el.playBtn) this.el.playBtn.hidden = !isMobile;
    if (this.el.desktopMsg) this.el.desktopMsg.hidden = isMobile;
    if (!isMobile && this.running) {
      this.endGame(false, 'closed');
    }
  };

  CandyCatch.prototype.bind = function () {
    var self = this;

    this.el.playBtn.addEventListener('click', function () {
      if (!self.isMobile) return;
      self.initAudio();
      self.openOverlay();
    });

    this.el.close.addEventListener('click', function () { self.closeOverlay(); });
    this.el.close2.addEventListener('click', function () { self.closeOverlay(); });
    this.el.blockedClose.addEventListener('click', function () { self.closeOverlay(); });

    this.el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(self.el.form);
      var first = (fd.get('first_name') || '').toString().trim();
      var last = (fd.get('last_name') || '').toString().trim();
      var email = (fd.get('email') || '').toString().trim();
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!first || !last || !emailOk) {
        self.el.formError.hidden = false;
        self.el.formError.textContent = !emailOk
          ? 'Please enter a valid email address.'
          : 'Please fill in your first and last name.';
        return;
      }
      self.el.formError.hidden = true;
      self.player = { first_name: first, last_name: last, email: email };
      self.el.formPanel.hidden = true;
      self.el.leaderboardPanel.hidden = false;
      self.showPlayerLeaderboard();
    });

    this.el.leaderboardContinue.addEventListener('click', function () {
      self.el.leaderboardPanel.hidden = true;
      if (self.hasSeenHowto) {
        self.startCountdown();
      } else {
        self.el.howtoPanel.hidden = false;
      }
    });

    this.el.howtoContinue.addEventListener('click', function () {
      self.el.howtoPanel.hidden = true;
      self.hasSeenHowto = true;
      self.startCountdown();
    });

    this.el.playAgain.addEventListener('click', function () {
      self.el.gameoverPanel.hidden = true;
      self.reset();
      self.updateHud();
      self.applyRandomPair();
      self.el.leaderboardPanel.hidden = false;
      self.showPlayerLeaderboard();
    });

    // pouch dragging: touch + mouse
    var dragging = false;

    function setPouchFromClientX(clientX) {
      var rect = self.el.playfield.getBoundingClientRect();
      var pct = (clientX - rect.left) / rect.width;
      pct = Math.max(0, Math.min(1, pct));
      self.pouchX = pct;
      self.renderPouch();
      if (self.running) {
        self.movementSamples.push({ t: performance.now(), x: pct });
        if (self.movementSamples.length > 300) self.movementSamples.shift();
      }
    }

    this.el.playfield.addEventListener('touchstart', function (e) {
      dragging = true;
      setPouchFromClientX(e.touches[0].clientX);
    }, { passive: true });
    this.el.playfield.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      setPouchFromClientX(e.touches[0].clientX);
    }, { passive: true });
    this.el.playfield.addEventListener('touchend', function () { dragging = false; });

    // mouse support so it can be tested on desktop / in the theme editor
    this.el.playfield.addEventListener('mousedown', function (e) {
      dragging = true;
      setPouchFromClientX(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      setPouchFromClientX(e.clientX);
    });
    window.addEventListener('mouseup', function () { dragging = false; });

    if (this.el.adminRefresh) {
      this.el.adminRefresh.addEventListener('click', function () { self.refreshLeaderboard(); });
    }
  };

  CandyCatch.prototype.applyRandomPair = function () {
    if (!this.pairs.length) return;
    var pair = this.pairs[Math.floor(Math.random() * this.pairs.length)];
    if (!pair) return;
    if (pair.pouch && this.el.pouchImg) this.el.pouchImg.src = pair.pouch;
    if (pair.candy && this.el.candyTpl) {
      var img = this.el.candyTpl.content.querySelector('[data-cc-candy-img]');
      if (img) img.src = pair.candy;
    }
  };

  CandyCatch.prototype.openOverlay = function () {
    this.el.overlay.hidden = false;
    document.documentElement.classList.add('candy-catch-lock');
    document.body.classList.add('candy-catch-lock');
    this.el.blockedPanel.hidden = true;
    this.el.formPanel.hidden = false;
    this.el.leaderboardPanel.hidden = true;
    this.el.howtoPanel.hidden = true;
    this.el.gameoverPanel.hidden = true;
    this.el.stage.hidden = true;
    this.el.countdown.hidden = true;
    this.el.form.reset();
    this.applyRandomPair();

    // re-check on every open, in case they closed devtools/automation between attempts
    this.automationDetected = detectAutomatedBrowser();
    if (this.automationDetected) {
      this.el.formPanel.hidden = true;
      this.el.blockedPanel.hidden = false;
    }
  };

  CandyCatch.prototype.closeOverlay = function () {
    this.stopLoop();
    this.el.overlay.hidden = true;
    document.documentElement.classList.remove('candy-catch-lock');
    document.body.classList.remove('candy-catch-lock');
    this.clearItems();
    this.reset();
    this.hasSeenHowto = false;
    this.updateHud();
  };

  CandyCatch.prototype.startCountdown = function () {
    var self = this;
    var n = 3;
    this.el.countdown.hidden = false;
    this.el.countdown.textContent = n;
    this.playCountdownTick();
    var timer = setInterval(function () {
      n -= 1;
      if (n <= 0) {
        clearInterval(timer);
        self.el.countdown.hidden = true;
        self.playGo();
        self.beginGame();
      } else {
        self.el.countdown.textContent = n;
        self.playCountdownTick();
      }
    }, 700);
  };

  CandyCatch.prototype.beginGame = function () {
    this.el.stage.hidden = false;
    this.updateHud();
    this.renderPouch();
    this.running = true;
    this.movementSamples = [];
    this.lastSpawn = 0;
    this.lastFrame = performance.now();
    this.loop();
    this.scheduleSpawn();
  };

  CandyCatch.prototype.scheduleSpawn = function () {
    var self = this;
    if (!this.running) return;
    this.spawnTimer = setTimeout(function () {
      self.spawnItem();
      self.scheduleSpawn();
    }, this.spawnInterval);
  };

  CandyCatch.prototype.spawnItem = function () {
    var isSugar = Math.random() < 0.18;
    var tpl = isSugar ? this.el.sugarTpl : this.el.candyTpl;
    var node = tpl.content.firstElementChild.cloneNode(true);
    var fieldWidth = this.el.playfield.clientWidth;
    var x = Math.random() * (fieldWidth - this.itemSize);
    node.style.width = this.itemSize + 'px';
    node.style.height = this.itemSize + 'px';
    node.style.left = x + 'px';
    node.style.top = '-' + this.itemSize + 'px';
    this.el.playfield.appendChild(node);
    var rotSpeed = (Math.random() * 4 + 2) * (Math.random() < 0.5 ? -1 : 1);
    this.items.push({ el: node, y: -this.itemSize, x: x, sugar: isSugar, caught: false, rot: Math.random() * 360, rotSpeed: rotSpeed });
  };

  CandyCatch.prototype.renderPouch = function () {
    var fieldWidth = this.el.playfield.clientWidth;
    var pouchWidth = this.el.pouch.offsetWidth || 120;
    var maxLeft = fieldWidth - pouchWidth;
    var left = this.pouchX * fieldWidth - pouchWidth / 2;
    left = Math.max(0, Math.min(maxLeft, left));
    this.el.pouch.style.left = left + 'px';
    this.el.pouch.style.transform = 'none';
    this._pouchLeft = left;
    this._pouchWidth = pouchWidth;
    var zoneWidth = pouchWidth * this.catchZoneRatio;
    this._catchZoneLeft = left + (pouchWidth - zoneWidth) / 2;
    this._catchZoneRight = this._catchZoneLeft + zoneWidth;
  };

  CandyCatch.prototype.loop = function () {
    if (!this.running) return;
    var self = this;
    var now = performance.now();
    var dt = Math.min(40, now - this.lastFrame);
    this.lastFrame = now;

    var fieldHeight = this.el.playfield.clientHeight;
    var pouchHeight = this.el.pouch.offsetHeight || 60;
    var pouchTopY = fieldHeight - 24 - pouchHeight;
    var catchBottomY = pouchTopY + pouchHeight * this.catchZoneHeightRatio;

    for (var i = this.items.length - 1; i >= 0; i--) {
      var item = this.items[i];
      item.y += this.speed * (dt / 16.6);
      item.rot += item.rotSpeed * (dt / 16.6);
      item.el.style.top = item.y + 'px';
      item.el.style.transform = 'rotate(' + item.rot + 'deg)';

      var itemCenterX = item.x + this.itemSize / 2;

      if (!item.caught && item.y >= pouchTopY && item.y <= catchBottomY) {
        if (itemCenterX >= this._catchZoneLeft && itemCenterX <= this._catchZoneRight) {
          item.caught = true;
          this.catchItem(item);
        }
      }

      if (item.y > fieldHeight + 20) {
        var missed = !item.caught && !item.sugar;
        this.removeItem(item, i);
        if (missed) {
          this.missedCandies += 1;
          this.updateHud();
          this.triggerFeedback();
          vibrate(120);
          this.playMiss();
          if (this.missedCandies >= this.missLimit) {
            this.endGame(true, 'missed');
            return;
          }
        }
      }
    }

    this.rafId = requestAnimationFrame(function () { self.loop(); });
  };

  CandyCatch.prototype.triggerFeedback = function () {
    var self = this;
    this.el.stage.classList.remove('cc-shake');
    this.el.flash.classList.remove('cc-active');
    void this.el.stage.offsetWidth;
    this.el.stage.classList.add('cc-shake');
    this.el.flash.classList.add('cc-active');
    clearTimeout(this._feedbackTimer);
    this._feedbackTimer = setTimeout(function () {
      self.el.stage.classList.remove('cc-shake');
      self.el.flash.classList.remove('cc-active');
    }, 350);
  };

  CandyCatch.prototype.spawnCatchEffect = function (isBad) {
    var pouchRect = this.el.pouch.getBoundingClientRect();
    var fieldRect = this.el.playfield.getBoundingClientRect();
    var x = pouchRect.left - fieldRect.left + pouchRect.width / 2;
    var y = pouchRect.top - fieldRect.top;
    var colorMain = isBad ? '220,53,69' : '255,209,64';

    var flash = document.createElement('div');
    flash.className = 'candy-catch__catch-flash' + (isBad ? ' candy-catch__catch-flash--bad' : '');
    flash.style.left = x + 'px';
    flash.style.top = y + 'px';
    this.el.playfield.appendChild(flash);
    setTimeout(function () { if (flash.parentNode) flash.parentNode.removeChild(flash); }, 350);

    var count = 10;
    for (var i = 0; i < count; i++) {
      var spark = document.createElement('span');
      spark.className = 'candy-catch__spark';
      var angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
      var dist = 26 + Math.random() * 26;
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist - 10;
      spark.style.left = x + 'px';
      spark.style.top = y + 'px';
      spark.style.setProperty('--cc-dx', dx + 'px');
      spark.style.setProperty('--cc-dy', dy + 'px');
      spark.style.background = 'rgb(' + colorMain + ')';
      this.el.playfield.appendChild(spark);
      (function (el) {
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 550);
      })(spark);
    }
  };

  CandyCatch.prototype.catchItem = function (item) {
    if (item.sugar) {
      this.sugarCaught += 1;
      this.updateHud();
      this.triggerFeedback();
      this.spawnCatchEffect(true);
      vibrate(120);
      this.playCatchSugar();
      this.removeItemImmediate(item);
      if (this.sugarCaught >= this.failLimit) {
        this.endGame(true, 'sugar');
        return;
      }
    } else {
      this.score += this.pointsPerCandy;
      this.speed = this.speed * (1 + this.speedIncrement);
      this.spawnInterval = Math.max(this.minSpawn, this.spawnInterval - this.spawnDecrement);
      this.updateHud();
      this.spawnCatchEffect(false);
      vibrate(20);
      this.playCatchCandy();
      this.removeItemImmediate(item);
    }
  };

  CandyCatch.prototype.removeItem = function (item, index) {
    this.removeItemImmediate(item);
  };

  CandyCatch.prototype.removeItemImmediate = function (item) {
    var idx = this.items.indexOf(item);
    if (idx > -1) this.items.splice(idx, 1);
    if (item.el && item.el.parentNode) item.el.parentNode.removeChild(item.el);
  };

  CandyCatch.prototype.clearItems = function () {
    var self = this;
    this.items.forEach(function (item) {
      if (item.el && item.el.parentNode) item.el.parentNode.removeChild(item.el);
    });
    this.items = [];
  };

  CandyCatch.prototype.updateHud = function () {
    this.el.score.textContent = this.score;
    this.el.sugarCaught.textContent = this.sugarCaught;
    this.el.sugarLimit.textContent = this.failLimit;
    this.el.missCaught.textContent = this.missedCandies;
    this.el.missLimitEl.textContent = this.missLimit;
  };

  CandyCatch.prototype.stopLoop = function () {
    this.running = false;
    if (this.rafId) cancelAnimationFrame(this.rafId);
    if (this.spawnTimer) clearTimeout(this.spawnTimer);
  };

  CandyCatch.prototype.detectRoboticInput = function () {
    var samples = this.movementSamples;
    if (samples.length < 25) return false; // not enough movement to judge — don't falsely flag short/still rounds

    var deltas = [];
    for (var i = 1; i < samples.length; i++) {
      deltas.push(samples[i].t - samples[i - 1].t);
    }
    var mean = deltas.reduce(function (a, b) { return a + b; }, 0) / deltas.length;
    var variance = deltas.reduce(function (a, b) { return a + Math.pow(b - mean, 2); }, 0) / deltas.length;
    var stdDev = Math.sqrt(variance);

    // real touch/mouse input is naturally jittery; near-zero timing variance
    // across many samples strongly suggests a scripted macro or autoclicker
    return stdDev < 1.5 && mean > 0;
  };

  CandyCatch.prototype.endGame = function (failed, reason) {
    this.stopLoop();
    this.clearItems();
    this.el.stage.hidden = true;
    this.el.gameoverPanel.hidden = false;
    this.suspectedCheat = this.automationDetected || this.detectRoboticInput();

    if (this.suspectedCheat) {
      this.el.gameoverTitle.textContent = 'Please play fair!';
      this.el.gameoverCopy.textContent = 'We detected unusually mechanical, non-human input during that round — this can happen with autoclickers, macros, or other automation tools. Please remove any such software or hardware and play again for your score to count.';
      this.el.finalScore.textContent = this.score + ' (not saved)';
      this.el.savedMsg.hidden = true;
      this.showGameoverLeaderboard();
      this.showLauncherLeaderboard();
      return;
    }

    if (failed) { vibrate(300); this.playFail(); }
    var isSugarFail = reason === 'sugar';
    var isMissFail = reason === 'missed';
    this.el.gameoverTitle.textContent = isSugarFail ? 'Too much sugar!' : (isMissFail ? 'Too many missed!' : 'Game over!');
    this.el.gameoverCopy.textContent = isSugarFail
      ? 'You caught ' + this.failLimit + ' sugar cubes. Try to dodge them next time!'
      : isMissFail
        ? 'You let ' + this.missLimit + ' candies fall past your pouch. Stay quicker on your feet!'
        : 'Nice run!';
    this.el.finalScore.textContent = this.score;
    this.el.savedMsg.hidden = true;
    this.sessionScores.push({
      first_name: this.player.first_name,
      last_name: this.player.last_name,
      email: this.player.email,
      score: this.score
    });
    this.showGameoverLeaderboard();
    this.showLauncherLeaderboard();
    this.saveScore();
  };

  CandyCatch.prototype.saveScore = function () {
    var self = this;
    var payload = {
      action: 'save_score',
      first_name: this.player.first_name,
      last_name: this.player.last_name,
      email: this.player.email,
      score: this.score,
      sugar_caught: this.sugarCaught,
      missed_candies: this.missedCandies,
      date: new Date().toISOString(),
      shop: window.location.hostname
    };

    // always keep a local best score as a fallback / offline copy
    try {
      var key = 'candyCatchBest_' + (this.player.email || 'anon');
      var prevBest = parseInt(localStorage.getItem(key) || '0', 10);
      if (this.score > prevBest) localStorage.setItem(key, String(this.score));
      var allScoresKey = 'candyCatchScores';
      var all = JSON.parse(localStorage.getItem(allScoresKey) || '[]');
      all.push(payload);
      localStorage.setItem(allScoresKey, JSON.stringify(all.slice(-100)));
    } catch (e) { /* storage unavailable, ignore */ }

    if (!this.webhookUrl) {
      this.el.savedMsg.hidden = false;
      this.el.savedMsg.textContent = 'Score saved on this device!';
      return;
    }

    fetch(this.webhookUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    }).then(function () {
      self.el.savedMsg.hidden = false;
      self.el.savedMsg.textContent = 'Score saved!';
    }).catch(function () {
      self.el.savedMsg.hidden = false;
      self.el.savedMsg.textContent = 'Saved on this device (could not reach the server).';
    });
  };

  CandyCatch.prototype.renderLeaderboardInto = function (listEl, emptyEl, rows) {
    if (!rows.length) {
      listEl.innerHTML = '';
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    listEl.innerHTML = rows.slice(0, 8).map(function (r, i) {
      var name = (r.first_name || '').toString().trim() || 'Anonymous';
      return '<li><span><span class="candy-catch__player-board-rank">' + (i + 1) + '</span>' + name + '</span><span class="candy-catch__player-board-score">' + (r.score || 0) + '</span></li>';
    }).join('');
  };

  CandyCatch.prototype.mergedLeaderboard = function () {
    var byKey = {};
    this.cachedLeaderboard.concat(this.sessionScores).forEach(function (r) {
      var key = (r.email || ((r.first_name || '') + (r.last_name || '')) || Math.random()).toString().trim().toLowerCase();
      var existing = byKey[key];
      if (!existing || (r.score || 0) > (existing.score || 0)) {
        byKey[key] = r;
      }
    });
    var merged = Object.keys(byKey).map(function (k) { return byKey[k]; });
    merged.sort(function (a, b) { return (b.score || 0) - (a.score || 0); });
    return merged;
  };

  CandyCatch.prototype.fetchAndRenderLeaderboard = function (listEl, emptyEl, loadingEl) {
    var self = this;
    // show instantly from whatever we already have, no network wait
    this.renderLeaderboardInto(listEl, emptyEl, this.mergedLeaderboard());

    if (!this.webhookUrl) return;

    loadingEl.hidden = false;
    fetch(this.webhookUrl + (this.webhookUrl.indexOf('?') > -1 ? '&' : '?') + 'action=leaderboard')
      .then(function (res) { return res.json(); })
      .then(function (rows) {
        if (Array.isArray(rows)) self.cachedLeaderboard = rows;
        self.renderLeaderboardInto(listEl, emptyEl, self.mergedLeaderboard());
        loadingEl.hidden = true;
      })
      .catch(function () {
        loadingEl.hidden = true;
        /* keep showing what we already rendered */
      });
  };

  CandyCatch.prototype.showPlayerLeaderboard = function () {
    this.fetchAndRenderLeaderboard(this.el.leaderboardList, this.el.leaderboardEmpty, this.el.leaderboardLoading);
  };

  CandyCatch.prototype.showGameoverLeaderboard = function () {
    this.fetchAndRenderLeaderboard(this.el.gameoverLeaderboardList, this.el.gameoverLeaderboardEmpty, this.el.gameoverLeaderboardLoading);
  };

  CandyCatch.prototype.showLauncherLeaderboard = function () {
    if (!this.el.launcherLeaderboardList) return;
    this.fetchAndRenderLeaderboard(this.el.launcherLeaderboardList, this.el.launcherLeaderboardEmpty, this.el.launcherLeaderboardLoading);
  };

  CandyCatch.prototype.refreshLeaderboard = function () {
    var self = this;
    // render instantly from cache + this session's scores while the network call is in flight
    var instant = this.mergedLeaderboard();
    if (instant.length) {
      this.el.adminEmpty.hidden = true;
      this.el.adminList.innerHTML = instant.slice(0, 10).map(function (r) {
        var name = (r.first_name || '') + ' ' + (r.last_name || '');
        return '<li>' + name.trim() + ' — ' + (r.score || 0) + ' pts</li>';
      }).join('');
    } else {
      this.el.adminList.innerHTML = '';
      this.el.adminEmpty.hidden = false;
    }

    if (!this.webhookUrl) return;

    this.el.adminLoading.hidden = false;
    fetch(this.webhookUrl + (this.webhookUrl.indexOf('?') > -1 ? '&' : '?') + 'action=leaderboard')
      .then(function (res) { return res.json(); })
      .then(function (rows) {
        if (Array.isArray(rows)) self.cachedLeaderboard = rows;
        var merged = self.mergedLeaderboard();
        if (!merged.length) {
          self.el.adminList.innerHTML = '';
          self.el.adminEmpty.hidden = false;
          self.el.adminLoading.hidden = true;
          return;
        }
        self.el.adminEmpty.hidden = true;
        self.el.adminList.innerHTML = merged.slice(0, 10).map(function (r) {
          var name = (r.first_name || '') + ' ' + (r.last_name || '');
          return '<li>' + name.trim() + ' — ' + (r.score || 0) + ' pts</li>';
        }).join('');
        self.el.adminLoading.hidden = true;
      })
      .catch(function () {
        self.el.adminEmpty.hidden = false;
        self.el.adminEmpty.textContent = 'Could not load leaderboard.';
        self.el.adminLoading.hidden = true;
      });
  };

  window.CandyCatchGame = {
    instances: {},
    init: function (root, sectionId) {
      if (!root) return;
      this.instances[sectionId] = new CandyCatch(root);
    }
  };
})();
